<template>
  <Content id="smenus">
    <div slot="search">
      <Search :model="search" :elem="searchElem" :btn-loading="list.loading" @on-search="handleDataList" :labelWidth="80"/>
    </div>
    <!-- Search -->
    <div slot="extra">
      <Button icon="md-add" @click="handleCreate">添加</Button>
    </div>
    <!-- extra -->
    <div v-if="toolbar.number" class="toolbar">
      <span class="number"> Selected {{ toolbar.number }} items </span>
      <Button type="error" icon="md-trash" @click="handleBatchRemove"> Remove </Button>
    </div>
    <!-- .toolbar -->
    <ITable ref="list" stripe :columns="columns" :loading="list.loading" :data="list.data" :total="list.total"
      @on-page-change="handleDataList" @on-selection-change="handleSelectionChange" />
    <!-- ITable -->
    <SmenuEdit ref="edit" @on-update="handleDataList" />
    <!-- MenuEdit -->
  </Content>
</template>
<script>
import {
  _delSmenu, // 删除
  _getSmenuList, // 列表,
  _getfindParent
} from "@/services/manage/smenus";
import SmenuEdit from "./SmenuEdit";
export default {
  name: "Smenus",
  components: {
    SmenuEdit
  },
  data() {
    return {
      // 工具条(批量删除)
      toolbar: {
        ids: [], // ID数组
        number: 0 // 选择数量
      },
      // 表单数据
      search: {
        name: ""
      },
      // 列表属性
      list: {
        data: [], // 结构化数据
        total: 0, // 数据总数
        loading: false // 加载状态
      },
      ParentList:[],
      // 表单元素
      searchElem: [
        {
          label: '页面名称',
          prop: "name",
          placeholder: "",
          icon: "md-search"
        }
      ],
      // 表格列的配置描述
      columns: [
        {
          title: "页面名称",
          key: "name",
          minWidth: 80
        },
        {
          title: "菜单名称",
          key: "alias",
          minWidth: 80
        }, {
          title: "菜单URL",
          key: "url",
          minWidth: 100,
        }, {
          title: "是否一级菜单",
          key: "firstMenu",
          minWidth: 100,
          render: (h, params) =>
            h('span', params.row.firstMenu === 1 ? "是" : "否")
        }, {
          title: "类型",
          key: "type",
          minWidth: 60,
          render: (h, params) =>
            h('span', params.row.type === 1 ? "菜单" : "子菜单")
        }, {
          title: "上级菜单",
          key: "parentId",
          minWidth: 120,
          render:(h,params)=>h('span',this.formatparentMemu(params))
        }, {
          title: "排序",
          key: "sort",
          minWidth: 60,
        }, {
          title: "操作员",
          key: "operator",
          minWidth: 80
        }, {
          title: "创建时间",
          key: "createTime",
          minWidth: 80
        }, {
          title: "状态",
          key: "status",
          minWidth: 60,
          render: (h, params) =>
            h('span', params.row.status === 1 ? "启用" : "禁用")
        },
        {
          title: "操作",
          key: "operation",
          align: "center",
          fixed: "right",
          minWidth: 150,
          render: (h, params) => this.$Utils.operatorBtn_FORMAT(h, params,
            {
              type: 'edit',
              confirm: false,
              callback: this.handleEdit
            },
            {
              type: 'delete',
              confirm: true,
              callback: this.handleRemove
            }
          )
        }
      ]
    };
  },
  mounted() {
    this.handleDataList(); // 获取列表数据
    _getfindParent().then(res=>{
      this.$nextTick(()=>{
        this.ParentList=res.data
      })
    })
  },
  methods: {
    /**
     * 获取用户列表
     * @param  {string} type 是否使用搜索, 默认值 undefined (不使用搜索)
     */
    handleDataList(type) {
      // this.$refs["list"].selectAll(false); // 取消全选
      console.log('chufa','搜索')
      this.$Loading.start();
      this.list.loading = true; // 列表加载状态
      const page = this.$refs["list"].handlePage(type); // 获取分页信息
      console.log(page,'page')
        const params={
           ...this.search,
          currentPage: page.current,
          pageSize: page.pageSize
        }
        _getSmenuList(params).then(res => {
          const { records, total } = res.data;
          this.list = {
            data: records,
            total: total,
            loading: false
          };
          this.$Loading.finish();
        })
          .catch(() => {
            this.$Loading.error();
            this.list.loading = false;
          });
    },
    // 新增界面
    handleCreate() {
      this.$refs["edit"].handleModal("添加菜单"); // 显示创建模态框
    },
    /**
     * 编辑界面
     * @param  {object} row 当前行数据
     */
    handleEdit(row) {
      this.$refs["edit"].handleModal("编辑菜单", row); // 显示编辑模态框
    },
    /**
     * 删除用户
     * @param  {object} row 当前行数据
     */
    handleRemove(row) {
      this.$Loading.start();
      this.list.loading = true;
      // 模拟异步请求(删除)
      setTimeout(() => {
        _delSmenu({
          id: row.id
        })
          .then(res => {
            this.$message.success(res.errmsg);
            this.handleDataList();
          })
          .catch(() => {
            this.$Loading.error();
            this.list.loading = false;
          });
      }, 500);
    },
    /**
     * 在多选模式下有效，只要选中项发生变化时就会触发
     * @param  {array} selection 已选项数据
     */
    handleSelectionChange(selection) {
      const ids = [];
      for (const item of selection) {
        ids.push(item["id"]);
      }
      this.toolbar = {
        ids: ids,
        number: selection.length
      };
    },
    formatparentMemu(params){
      let list=this.ParentList
      let q='';
      this.ParentList.forEach(item=>{
        if (item.id==params.row.parentId){
         return  q=item.alias
        }
      })
      return q
    }
  }
};
</script>
<style lang="postcss" scoped>
.toolbar {
  margin-bottom: 24px;
  text-align: right;

  & .number {
    margin-right: 8px;
  }
}
</style>
